import ReactGA from "react-ga4";
import React from "react";

// Privacy and consent management utilities
export const consentManager = {
  // Check if user has given consent
  hasConsent: () => {
    return localStorage.getItem("analytics_consent") === "true";
  },

  // Grant consent and enable tracking
  grantConsent: () => {
    localStorage.setItem("analytics_consent", "true");
    ReactGA.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted"
    });
    // Re-enable GA4 tracking
    ReactGA.initialize(
      process.env.REACT_APP_GA_MEASUREMENT_ID || "G-NQBQWSGNMS",
      {
        testMode: process.env.NODE_ENV === "development"
      }
    );
  },

  // Deny consent and disable tracking
  denyConsent: () => {
    localStorage.setItem("analytics_consent", "false");
    ReactGA.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied"
    });
  },

  // Show consent banner
  showConsentBanner: () => {
    // Consent banner implementation - customize this to show your UI component
    // For now, we'll silently deny consent to avoid popups
    console.log("Analytics consent required - implement your consent UI here");
    // consentManager.denyConsent(); // Default to denied without popup
  },

  // Initialize consent on app load
  initializeConsent: () => {
    const hasConsent = consentManager.hasConsent();

    if (hasConsent === null) {
      // First time user - default to granted (no popup)
      consentManager.grantConsent();
    } else if (hasConsent) {
      // User has previously consented
      ReactGA.gtag("consent", "default", {
        analytics_storage: "granted",
        ad_storage: "granted"
      });
    } else {
      // User has denied consent
      ReactGA.gtag("consent", "default", {
        analytics_storage: "denied",
        ad_storage: "denied"
      });
    }
  }
};

// React hook for consent management
export const useConsent = () => {
  const [hasConsent, setHasConsent] = React.useState(
    consentManager.hasConsent()
  );

  const grantConsent = () => {
    consentManager.grantConsent();
    setHasConsent(true);
  };

  const denyConsent = () => {
    consentManager.denyConsent();
    setHasConsent(false);
  };

  return {
    hasConsent,
    grantConsent,
    denyConsent,
    showConsentBanner: consentManager.showConsentBanner
  };
};
